import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';

import React, { useEffect, useState } from 'react';
import { Roles } from '../../enums/roles-enum';
import {
  findValueInData,
  getResellerFilterData,
} from '../../helpers/filters.helpers';
import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useDidMountEffect from '../../hooks/useDidMountEffect';
import { EntityFilterData, EntityIdFilterData } from '../../type/filter.types';

interface Props {
  filterSelectData: UseFormReturnType<EntityFilterData>;
  filterValues: UseFormReturnType<EntityIdFilterData>;
  isPartnerDependent?: boolean;
  error?: React.ReactNode;
}

function SelectResellerFilter(props: Props) {
  const { filterSelectData, filterValues, isPartnerDependent, error } = props;
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const noData = 'No data';
  const loadingData = 'Loading...';
  const { auth } = useAuth();

  const loadResellers = async (partnerId?: string) => {
    setIsLoading(true);

    const resellers = await getResellerFilterData(axiosPrivate, partnerId);

    if (filterValues.values.reseller && resellers) {
      const found = findValueInData(resellers, filterValues.values.reseller);
      if (!found) {
        filterValues.setFieldValue('reseller', '');
      }
    }

    filterSelectData.setFieldValue('resellersData', resellers);

    setIsLoading(false);
  };

  useEffect(() => {
    if (isPartnerDependent) {
      return;
    }

    if (auth?.role === Roles.PARTNER) {
      loadResellers();
    }

    // if (isLoadResellers) {
    //   loadResellers();
    // } else {
    //   setIsLoadResellers(true);
    // }
  }, []);

  useDidMountEffect(() => {
    if (!isPartnerDependent) {
      return;
    }

    if (filterValues.values.partner && filterValues.values.partner !== noData) {
      loadResellers(filterValues.values.partner);
    } else {
      filterValues.setFieldValue('reseller', '');
      filterSelectData.setFieldValue('resellersData', []);
    }
  }, [filterValues.values.partner]);

  const getData = () => {
    let data = isLoading
      ? [loadingData]
      : filterSelectData.values.resellersData?.length === 0 ||
        filterSelectData.values.resellersData === undefined
      ? [noData]
      : filterSelectData.values.resellersData;

    if (isPartnerDependent) {
      data = isLoading
        ? [loadingData]
        : (filterSelectData.values.resellersData?.length === 0 &&
            filterValues.values.partner) ||
          filterSelectData.values.resellersData === undefined
        ? [noData]
        : filterSelectData.values.resellersData;
    }

    return data;
  };

  const getValue = () => {
    let value = isLoading
      ? loadingData
      : filterSelectData.values.resellersData?.length === 0 ||
        filterSelectData.values.resellersData === undefined
      ? noData
      : filterValues.values.reseller;

    if (isPartnerDependent) {
      value = isLoading
        ? loadingData
        : (filterSelectData.values.resellersData?.length === 0 &&
            filterValues.values.partner) ||
          filterSelectData.values.resellersData === undefined
        ? noData
        : filterValues.values.reseller;
    }

    return value;
  };

  const getDisabled = () => {
    let disabled =
      isLoading ||
      filterSelectData.values.resellersData?.length === 0 ||
      filterSelectData.values.resellersData === undefined;

    if (isPartnerDependent) {
      disabled =
        isLoading ||
        filterSelectData.values.resellersData?.length === 0 ||
        filterSelectData.values.resellersData === undefined ||
        !filterValues.values.partner;
    }
    return disabled;
  };

  return (
    <>
      <Select
        label='Select Reseller'
        data={getData()}
        value={getValue()}
        disabled={getDisabled()}
        onChange={(value: string) =>
          filterValues.setFieldValue('reseller', value)
        }
        clearable={!getDisabled()}
        searchable
        error={error}
      />
    </>
  );
}

export default SelectResellerFilter;
